import React from "react";

/**
 * Stacked up/down chevrons in a small “button” affordance for expandable dropdown rows.
 */
export function DropdownChevronPair({
  className = "",
}: {
  /** Wrapper classes — set text-* for icon color (stroke uses currentColor) */
  className?: string;
}) {
  return (
    <span
      className={`inline-flex flex-col items-center justify-center shrink-0 rounded-lg border px-1 py-0.5 text-current ${className}`}
      aria-hidden
    >
      <svg
        width="12"
        height="8"
        viewBox="0 0 24 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 -mb-px"
      >
        <polyline points="6 9 12 3 18 9" />
      </svg>
      <svg
        width="12"
        height="8"
        viewBox="0 0 24 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0"
      >
        <polyline points="18 3 12 9 6 3" />
      </svg>
    </span>
  );
}
